var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[(_vm.classObj.mobile && _vm.sidebar.opened)?_c('div',{staticClass:"drawer-bg",on:{"click":_vm.handleClickOutside}}):_vm._e(),_c('div',{staticClass:"main-container"},[_c('navbar',{attrs:{"showLogo":true}}),_c('app-main',{staticClass:"app-container"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }